/* App.css - Minimal custom styles, prefer MUI theme */

.Auth-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.Auth-form {
  width: 420px;
  padding-top: 30px;
  padding-bottom: 20px;
  border-radius: 8px;
}

.Auth-form-content {
  padding-left: 12%;
  padding-right: 12%;
}

.Auth-form-title {
  text-align: center;
  margin-bottom: 1em;
  font-size: 24px;
  font-weight: 800;
}
